import { useState } from 'react';
import { Stack } from '@mui/material';
import {
  ExpandableContentButton,
  ExpandableContentWrapper,
} from 'components/shared';
import {
  VixChartSettings,
  VixZoomOutButton,
  VixDownloadButton,
  VixProvider,
} from 'components/implied_vol/Vix';
import VixChart from 'components/implied_vol/Vix/VixChart';
import { CanvasComponentConfig, CanvasContentId } from 'types/canvas';
import { DEFAULT_VIX_CONFIG, VixConfig } from 'types';

interface CanvasVixChartProps {
  id: number;
  config: CanvasComponentConfig;
  onConfigChange: (patch: Partial<VixConfig>) => void;
}

const CanvasVixChart = ({
  id,
  config: canvasConfig,
  onConfigChange,
}: CanvasVixChartProps) => {
  const [localConfig, setLocalConfig] = useState<VixConfig>(() => ({
    ...DEFAULT_VIX_CONFIG,
    ...(canvasConfig as Partial<VixConfig>),
  }));

  const handleConfigChange = (patch: Partial<VixConfig>) => {
    setLocalConfig((prev) => {
      const next = { ...prev, ...patch };
      onConfigChange(patch);
      return next;
    });
  };

  const expandableContentButtonType = `${CanvasContentId.VIX_CHART}-${id}`;

  return (
    <VixProvider config={localConfig} onConfigChange={handleConfigChange}>
      <ExpandableContentWrapper
        type={expandableContentButtonType}
        styleOverrides={{ p: 1, height: '100%' }}
      >
        <Stack
          direction="column"
          spacing={1}
          sx={{ height: '100%', width: '100%' }}
        >
          <Stack
            sx={{
              px: 1,
              py: 0.5,
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <VixZoomOutButton />
            <VixDownloadButton />
            <VixChartSettings />
            <ExpandableContentButton type={expandableContentButtonType} />
          </Stack>
          <VixChart />
        </Stack>
      </ExpandableContentWrapper>
    </VixProvider>
  );
};

export default CanvasVixChart;
